module.exports = __webpack_public_path__ + "fonts/montserrat-v30-latin-600.a4fbb9f.woff2";